var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
//import nem from 'nem-sdk';
//import localForage from 'localforage';
import nemWrapper from './nemWrapper';
import axios from 'axios';
import helper from './helper';
var others = /** @class */ (function () {
    function others() {
        var _this = this;
        /*htmlにわたす */
        this.address = '';
        this.privateKey = '';
        this.publicKey = '';
        this.nem = new nemWrapper();
        this.today = "";
        this.HH = "00";
        this.mm = "00";
        this.working_status = "";
        this.working_status_flag = false;
        this.in_at = "";
        this.out_at = "";
        this.last_data = [];
        this.helper = new helper();
        this.setPlaceholder();
        this.load() //address取得
            .then(function () {
            _this.getStatus();
        }).catch(function (error) {
            console.error(error);
        });
    }
    // ローカルストレージから取得.
    /*async load() {
        let key = 'SmartUQ-Wallet'
        let result:any = await localForage.getItem(key)
        if (result !== null) {
            this.address = result.address
            this.privateKey = this.helper.Decrypt(result.privateKey)
            this.publicKey = result.publicKey
        }
        let key2 = 'Company-Info'
        let result2:any = await localForage.getItem(key2)
        if (result2 == null) {
            result2 = await this.nem.getCompanyInfoFromAPI(this.address)
        }

        return result
    }*/
    // ローカルストレージから取得.
    others.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        console.log("in kintaikanri load1");
                        return [4 /*yield*/, this.helper.load('SmartUQ-Wallet')];
                    case 1:
                        result = _b.sent();
                        if (!(result !== null)) return [3 /*break*/, 3];
                        this.address = result.address;
                        _a = this;
                        return [4 /*yield*/, this.helper.Decrypt(result.privateKey)];
                    case 2:
                        _a.privateKey = _b.sent();
                        this.publicKey = result.publicKey;
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    others.prototype.getStatus = function () {
        var _this = this;
        var key = 'TimeCard';
        console.log("in kintaikanri getstatus");
        //let result:any =  await this.helper.load(key)
        this.getStatusFromAPI().then(function (result) {
            if (result != undefined)
                _this.setStatus(result, key);
        });
    };
    others.prototype.setStatus = function (result, key) {
        this.working_status = result.working_status;
        if (this.working_status == "勤務中") {
            this.working_status_flag = true;
        }
        else {
            this.working_status_flag = false;
        }
        this.in_at = result.in_at;
        this.out_at = result.out_at;
        var y = result.in_at_y;
        var m = result.in_at_m;
        var d = result.in_at_d;
        var hh = parseInt(this.in_at.slice(2, 4));
        var mm = parseInt(this.in_at.slice(5, 7));
        this.in_at_date = new Date(y, m, d, hh, mm);
        console.log(this.in_at_date);
        this.last_data = result.last_data;
        //this.helper.save(key,result)
    };
    others.prototype.getStatusFromAPI = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, url, headers, access_token, uid, client, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = [];
                        if (!(this.address != null && this.address != "")) return [3 /*break*/, 3];
                        url = this.helper.path + "auth_users/working_status/" + this.address;
                        console.log(url);
                        console.log("in kintaikanri getstatus from api");
                        return [4 /*yield*/, this.helper.loadHeaders()];
                    case 1:
                        headers = _a.sent();
                        access_token = headers["access-token"];
                        uid = headers["uid"];
                        client = headers["client"];
                        return [4 /*yield*/, axios.get(url, {
                                headers: { "Content-Type": "application/json",
                                    "access-token": access_token,
                                    "uid": uid,
                                    "client": client },
                                data: {}
                            }).then(function (response) {
                                console.log('status:', response.status); // 200
                                console.log(response.data);
                                result = response.data.data[0];
                                // catchでエラー時の挙動を定義する
                            }).catch(function (error) {
                                if (error.response && error.response.status == "401") {
                                    console.log("please login");
                                    _this.helper.pleaseLogin();
                                }
                            })];
                    case 2:
                        response = _a.sent();
                        console.log(result);
                        return [2 /*return*/, result];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    others.prototype.setPlaceholder = function () {
        var today = new Date();
        var year = today.getFullYear();
        var month = ("0" + (today.getMonth() + 1)).slice(-2);
        var day = ("0" + today.getDate()).slice(-2);
        this.today = year + "-" + month + "-" + day;
        this.HH = ('0' + today.getHours()).slice(-2);
        this.mm = ('0' + today.getMinutes()).slice(-2);
    };
    return others;
}());
export default others;



//////////////////
// WEBPACK FOOTER
// ./src/ts/kintaiKanri.ts
// module id = 672
// module chunks = 1